import { ExportProps } from '~types/exportProps';

import { formatDateString, formatTimeString } from '~libs/dayjs';

import { selectLookupAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';
import { selectAppointmentStatuses } from '~appointments/selectors/statuses';
import { selectClientPackages } from '~main/selectors/clients/clientPackages';

const fields: ExportProps = {
  reference_number: {
    type: 'text-like',
    caption: 'Reference Number',
    checked: true,
    field: 'reference_number',
    placeholder: 'Filter..',
    columnDef: {
      id: 'reference_number',
      header: 'Reference Number',
      type: 'text',
    },
  },
  client_name: {
    type: 'text-like',
    caption: 'Client',
    checked: true,
    field: 'client.full_name',
    placeholder: 'Filter..',
    columnDef: {
      id: 'client.full_name',
      header: 'Client',
      type: 'text',
      deriveValue: (row) => row.client?.full_name ?? '',
    },
  },
  care_worker: {
    type: 'text-like',
    caption: 'Care Worker',
    checked: true,
    field: 'user.full_name',
    placeholder: 'Filter..',
    columnDef: {
      id: 'user.full_name',
      header: 'Care Worker',
      type: 'text',
      deriveValue: (row) => row.user?.full_name ?? '',
    },
  },
  date: {
    type: 'date-range',
    field: 'date',
    caption: 'Date',
    checked: true,
    columnDef: {
      id: 'date',
      header: 'Date',
      type: 'text',
      deriveValue: (row) => formatDateString(row.date),
    },
  },
  start_time: {
    type: 'time-range',
    field: 'start_time',
    caption: 'Start Time',
    columnDef: {
      id: 'start_time',
      header: 'Start Time',
      type: 'text',
      deriveValue: (row) => formatTimeString(row.start_time),
    },
  },
  end_time: {
    type: 'time-range',
    field: 'end_time',
    caption: 'End Time',
    columnDef: {
      id: 'end_time',
      header: 'End Time',
      type: 'text',
      deriveValue: (row) => formatTimeString(row.end_time),
    },
  },
  duration: {
    type: 'text',
    caption: 'Duration (mins)',
    field: 'duration',
    columnDef: {
      id: 'duration',
      header: 'Duration (mins)',
      type: 'text',
    },
  },
  status: {
    type: 'multi-lookup',
    field: 'status_id',
    columnField: 'status.name',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectAppointmentStatuses,
    columnDef: {
      id: 'status_id',
      header: 'Status',
      type: 'text',
      deriveValue: (row) => row.status?.name ?? '',
    },
  },
  referrer: {
    type: 'text-like',
    field: 'client.referrer_name',
    caption: 'Referrer',
    placeholder: 'Filter..',
    columnDef: {
      id: 'client.referrer_name',
      header: 'Referrer',
      type: 'text',
      deriveValue: (row) => row.client?.referrer_name ?? '',
    },
  },
  client_package: {
    type: 'multi-lookup',
    field: 'package_fixed_id',
    columnField: 'package_fixed.name',
    caption: 'Package',
    placeholder: 'All',
    selectorOptions: selectClientPackages,
    columnDef: {
      id: 'package_fixed.name',
      header: 'Package',
      type: 'text',
      deriveValue: (row) => row.package_fixed?.name ?? '',
    },
  },
  service_type: {
    type: 'multi-lookup',
    field: 'service_type_id',
    columnField: 'service_type.name',
    caption: 'Service Type',
    placeholder: 'All',
    selectorOptions: selectLookupAppointmentServiceTypes,
    columnDef: {
      id: 'service_type.name',
      header: 'Service Type',
      type: 'text',
      deriveValue: ({ service_type }) =>
        service_type ? `${service_type.name}${service_type.deleted ? ' - DELETED' : ''}` : '',
    },
  },
};

export default fields;
